import type { TipoInteracao } from "./api";

// Extraído de ConsultaInstituicaoInteracao quando a Ficha da instituição
// precisou do mesmo mapa de labels — segunda ocorrência real.
export const TIPO_INTERACAO_LABEL: Record<TipoInteracao, string> = {
  SU: "Suporte",
  CB: "Cobrança",
  CN: "Contato",
  TR: "Treinamento",
  CA: "Cobrança automatica",
  SA: "Suporte automatico",
};
